import { SetupPermission } from 'src/app/core';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const BrandIq: SetupPermission = PermissionsC.setupPages({
  pageLabels: ['brandiq-basic'],
  productLineLabel: 'brandiq',
});
